import styled from 'styled-components'

export const Wrapper = styled.div``

export const CreateContestContainer = styled.div`
  margin: 6rem 20px 0 20px;

  .name {
    h2 {
      font-family: ${({ theme }) => theme.fontFamily.inter};
      font-style: normal;
      font-weight: 600;
      font-size: ${({ theme }) => theme.fontSize.xl};
      margin: 0;
      padding-bottom: 7px;
      color: ${({ theme }) => theme.colors.black};
    }
  }

  .btn_wrapper {
    height: 300px;
    display: flex;
    position: relative;
    margin-top: 20px;
  }

  .contest_proceed_btn {
    align-self: flex-end;
    position: absolute;
    bottom: 10px;
  }
`

export const CreateContestForm = styled.form``
